

const GetGroupAndChildren = (str) => {
  str.replace(/\s+/g, ' ').replace(/(^[\s,]+|[\s,]+$)/g, '');
  let perens = 0;
  let inquotes = false;

  let group;
  let children;

  for (let i = 0; i < str.length; i++) {

    if (str[i] === '"' && str[i-1] !== "\\") {
      inquotes = !inquotes;
      continue;
    }

    if (str[i] == '(' && !inquotes) {
      perens++;
    } else if (str[i] == ')' && !inquotes) {
      perens--;
    } else if (str[i] == '{' && perens == 0 && !inquotes) {
      return {
        group: str.slice(0, i).replace(/\s/g, ' ').replace(/(^\s+|\s+$)/g, ''),
        children: str.slice(i + 1, str.length - 1).replace(/(^\s+|\s+$)/g, '')
      }
    }
  }

  return false;
};

const GetNameAndParams = (str) => {
  for (let i = 0; i < str.length; i++) {
    if (str[i] == '(') {
      return {
        name: str.slice(0,i).replace(/\s+/g, ''),
        params: str.slice(i + 1, str.length - 1)
      };
    }
  }

  return {
    name: str,
    params:false
  };
};

export default class Graph {
  constructor(graph = '') {
    graph = graph.replace(/(^[\s,]+|,?[\s,]+$)/g, '');

    if (graph[0] === '{') {
      graph = `query ${graph}`;
    }

    this.graph = this.fromString(graph.replace(/^\s*(#|\/\/).*$/gm,''));

    // return new Proxy(this, {
    //     get(target, prop) {
    //         if (Number(prop) === prop && !(prop in target)) {
    //             return target.graph.children[prop];
    //         }
    //         return target[prop];
    //     }
    // })
  }

  fromString(str) {
    let parts = GetGroupAndChildren(str);
    if (parts && parts.group) {
      let group = parts.group;
      const children = parts.children;

      group = group.replace(/(^[\s,]+|,?[\s,]+$)/g, '');
      return new Node(group, children);
    }

    return '';
  }

  toString() {
    return this.graph.toString().replace(/(^[\s,]+|[\s,]+$)/g, '');
  }

  find(key, deep = false) {
    return parseNodes(this.graph, key, deep);
  }

  merge(newNode) {
    this.graph.merge(newNode);
  }
}

const parseNodes = (node, key, deep = false, depth = 0) => {
  if (node.nodeName === key) {
    return node;
  }

  let currentNode = null;
  for (var i = 0; i < node.children.length; i++) {
    let nodeFound;
    if (node.children[i] instanceof Node) {
      if (deep || depth < 1) {
        nodeFound = parseNodes(node.children[i], key, deep, depth + 1);
      }

      if(nodeFound) {
        return nodeFound;
      }
    }
  }

  return false;
};

export class Node {
    nodeName = '';
    nodeParameters = {};
    children = [];

    constructor(name, children = '') {
      this.parseName(name);
      if (typeof children === 'string') {
        this.parseChildren(children);
        // let { group, children } = GetGroupAndChildren(children);
        //
        // this.children.push(group, children);
      }
    }

    normalizeValue = (value, isQuoted=false) => {
      const i = Number(value);

      if (!isNaN(i) && !isQuoted) {
        return i;
      }

      if (value === 'true') {
        return true;
      } else if (value === 'false') {
        return false;
      }

      if (value === 'null') {
        return null;
      }

      return value;
    }

    parseParams(params) {
      let out = {};

      try {
        out = eval(`(function() {return {${params.replace(/(^[\s,]+|,?[\s,]+$)/g, '')}}})()`);
      } catch (e) {
        console.error(e);
        console.error('Failed to parse params. ', params);
      }

      return out;
    }

    paramsToString(params) {
      let out = [];

      if (Array.isArray(params)) {
        out.push(`[${params.map(v=>{
          if (v === null) {
            return null;
          }
          if (Array.isArray(v)) {
            return `[${this.paramsToString(v)}]`;
          } else if (typeof v === 'object') {
            return `{${this.paramsToString(v)}}`;
          } else {
            if (typeof v === 'string') {
              v = `"${v}"`;
            }
            return v;
          }
        }).join(',')}]`);
      } else if (typeof params === 'object') {
        let _k = '';
        let _v = '';
        for (var key in params) {
          _k = key;
          _v = params[key];

          if (_v === null) {
            out.push(`${_k}:null`);
            continue;
          }

          if (Array.isArray(_v)) {
            _v = this.paramsToString(_v);
          } else if (typeof _v === 'object') {
            _v = `{${this.paramsToString(_v)}}`;
          } else {
            if (typeof _v === 'string') {
              _v = `"${_v}"`;
            }
          }

          out.push([_k,_v].filter(c=>c!==null).join(':'));
        }
      }

      return out.join(',');
    }

    parseName(name) {
      const parts = GetNameAndParams(name);
      name = parts.name;
      if (parts.params) {
        this.nodeParameters = this.parseParams(parts.params);
      }

      this.nodeName = name.replace(/(^[\s,]+|,?[\s,]+$)/g, '');
    }

    parseChildren(input) {
      input = input.replace(/\s+/g, ' ');
      const children = [];
      let hasFoundBrace = false;
      let inQuote = false;
      let parenCount = 0;
      let braceCount = 0;

      for (let i = 0; i < input.length; i++) {
        if (input[i] === '"' && input[i-1] !== '\\') {
          inQuote = !inQuote;
          continue;
        } else if (input[i] === '(' && !inQuote) {
          parenCount++;
          continue;
        } else if (input[i] === ')' && !inQuote) {
          parenCount--;
          continue;
        } else if (input[i] === '{' && !inQuote && parenCount === 0) {
          braceCount++;
          hasFoundBrace = true;
          continue;
        } else if (input[i] === '}' && !inQuote && parenCount === 0) {
          braceCount--;
          continue;
        } else if ((input[i] === ',' || input[i] === '\n') && !inQuote && parenCount === 0 && braceCount === 0 && !hasFoundBrace) {
          this.addChild(input.slice(0,i).replace(/(^[\s,]+|[\s,]+$)/g, ' '));
          input = input.slice(i+1).replace(/(^[\s,]+|[\s,]+$)/g, ' ');
          i = 0;
          continue;
        }

        if (hasFoundBrace && parenCount === 0 && braceCount === 0) {
          this.addChild(input.slice(0,i+1).replace(/(^[\s,]+|[\s,]+$)/g, ' '));
          input = input.slice(i+1).replace(/(^[\s,]+|[\s,]+$)/g, ' ');
          i = 0;
          hasFoundBrace = false;
        }
      }

      if (input.replace(/(^[\s,]+|[\s,]+$)/g, ' ') !== ' ') {
        this.addChild(input);
      }

    }

    addChild(child) {
      if (typeof child === 'string') {
        child = child.replace(/(^[\s,]+|,?[\s,]+$)/g, '');
        if (child === '') return;
        if (/[{}]/g.test(child)) {
          child = (new Graph(child)).graph;
        }
      } else if (!(child instanceof Node)) {
        throw new Error('A Child should be a string or a Node');
      }

      if (typeof child === 'string' && this.children.indexOf(child) > -1) {
        return;
      }
      this.children.push(child);
    }

    find(key, deep = false) {
      return parseNodes(this, key, deep);
    }

    merge(newNode) {
      if (newNode instanceof Graph) {
        newNode = newNode.graph;
      }

      const node = this.find(newNode.nodeName, false);
      if (node) {
        for (var i = 0; i < newNode.children.length; i++) {
          const n = node.find(newNode.children[i].nodeName, false);
          if (n) {
            n.nodeParameters = Object.assign({}, n.nodeParameters, newNode.children[i].nodeParameters);
            n.merge(newNode.children[i]);
          } else {
            node.addChild(newNode.children[i]);
          }
        }
      }
    }

    toString() {
      let params = jsonToInputParams(this.nodeParameters);

      if (params !== '') {
        params = `(${params})`;
      }

      return `
            ${this.nodeName} ${params} {
                ${ this.children.map((c) => c.toString()).join(',') }
            }
      `.replace(/\s+/g, ' ').replace(/(^[\s,]+|[\s,]+$)/g, '');
    }
}

Graph.format = (str) => {
  let out = '';
  let tabCount = 0;
  let inparen = false;
  for (var i = 0; i < str.length; i++) {
    let c = str[i];

    if (!inparen) {
      if (c === '{') {
        tabCount++;
      } else if (c === '}') {
        tabCount--;
      }
    }

    let nl = Array(tabCount).fill('  ').join('');

    switch (c) {
    case '(':
      inparen = true;
      out += c;
      break;
    case ')':
      inparen = false;
      out += c;
      break;
    case '{':
      if(inparen) {
        out += c;
        break;
      }
      out += ` ${c}\n${nl}`;
      break;
    case '}':
      if(inparen) {
        out += c;
        break;
      }
      out += `\n${nl}${c}`;
      break;
    case ',':
    case '\n':
    case '\r':
      if(inparen) {
        out += c;
        break;
      }
      out += `${c}\n${nl}`;
      break;
    default:
      out += c;
    }
  }
  return out;
};

const jsonArrayToInputParams = (data, depth) => {
  let out = [];

  for (let i = 0; i < data.length; i++) {
    out.push(parseRootElement(data[i], depth));
  }

  return out.join(',');
};

const jsonObjectToInputParams = (data, depth) => {
  let out = [];
  for (var key in data) {
    if (!key) continue;
    if (typeof data[key] === 'object' && data[key] !== null) {
      out.push(`${key}:${parseRootElement(data[key], depth)}`);
    } else if (data[key] !== null && typeof data[key] !== 'undefined') {
      let val = data[key];

      if (typeof val === 'string') {
        val = `"${val.replace(/"/g, '\\"').replace(/"[^"\\]*(?:\\.[^"\\]*)*"/g, (match) => match.replace(/"/g, '\\"'))}"`;
      }

      out.push(`${key}:${val}`);
    } else if (data[key] === null) {
      out.push(`${key}:null`);
    }
  }
  return out.join(',');
};

const parseRootElement = (data, depth=0) => {
  let out = data;

  if (Array.isArray(data)) {
    if (data.length === 0) {
      return '[]';
    }
    out = `[${jsonArrayToInputParams(data, depth++)}]`;
  } else if (typeof data === 'object' && data !== null) {
    if (Object.keys(data).length === 0) {
      return '';
    }
    out = `{${jsonObjectToInputParams(data, depth++)}}`;
  } else if (typeof data === 'string') {
    out = `"${out}"`;
  }

  if (typeof out === 'string') {
    out = out.replace(/\n/g, '\\n');
  }

  return out;
};

export const jsonToInputParams = (data) => {
  return parseRootElement(data).replace(/(\r|\n|\t)/g, '\\n').replace(/(^[\s]+|[\s]+$)/g, '').replace(/(^[{]|[}]$)/g, '');
};
